const actions = {
	GET_RETELL_LECTURE: 'GET_RETELL_LECTURE',
	GET_RETELL_LECTURE_SUCCESS: 'GET_RETELL_LECTURE_SUCCESS',

	CREATE_NEW_QUESTION_RETELL_LECTURE: 'CREATE_NEW_QUESTION_RETELL_LECTURE',
	CREATE_NEW_QUESTION_RETELL_LECTURE_SUCCESS: 'CREATE_NEW_QUESTION_RETELL_LECTURE_SUCCESS',

	DELETE_RETELL_LECTURE: 'DELETE_RETELL_LECTURE',
	DELETE_RETELL_LECTURE_SUCCESS: 'DELETE_RETELL_LECTURE_SUCCESS',

	GET_RETELL_LECTURE_DETAIL: 'GET_RETELL_LECTURE_DETAIL',
	GET_RETELL_LECTURE_DETAIL_SUCCESS: 'GET_RETELL_LECTURE_DETAIL_SUCCESS',

	UPDATE_RETELL_LECTURE_DETAIL: 'UPDATE_RETELL_LECTURE_DETAIL',
	UPDATE_RETELL_LECTURE_DETAIL_SUCCESS: 'UPDATE_RETELL_LECTURE_DETAIL_SUCCESS',

	SPEAKING_LOADING_FALSE: 'SPEAKING_LOADING_FALSE',
	//#region CRUD

	getRetellLecture: (model) => ({
		type: actions.GET_RETELL_LECTURE,
		payload: { model },
	}),

	createQuesRetellLecture: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_RETELL_LECTURE,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getRetellLectureDetail: (id) => ({
		type: actions.GET_RETELL_LECTURE_DETAIL,
		payload: { id },
	}),

	updateRetellLectureDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_RETELL_LECTURE_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteRetellLecture: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_RETELL_LECTURE,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
